module.exports = __webpack_public_path__ + "img/society1.15c2bf01.png";